export enum EmployeeDocumentUploadModeEnum {
  SINGLE_FILE = "SINGLE_FILE",
  FRONT_AND_BACK_IMAGES = "FRONT_AND_BACK_IMAGES",
}
